export default "__VITE_ASSET__ZQHR$b9K__"